import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Fragment, Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import CheckboxGroupItem from './CheckboxGroupItem';
import DefaultCheckbox from './Checkbox';
import cuid from 'cuid';
import { withVDSManager } from '@vds-core/utilities';
var propTypes = {
  /**
   * @ignore If provided, Checkbox components will be rendered based on this data
   * @typeName checkboxData
   */
  data: PropTypes.arrayOf(PropTypes.shape({
    children: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.node]),
    name: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    error: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
    disabled: PropTypes.bool,
    errorText: PropTypes.string,
    onChange: PropTypes.func,
    selected: PropTypes.bool
  })),

  /**
   * If provided, width of Checkbox components will be rendered based on this value
   */
  childWidth: PropTypes.string,

  /**
   * An object containing number of Checkbox components per row, in each viewport
   */
  rowQuantity: PropTypes.object,

  /**
   * Viewport the Buttons will be rendered in
   */
  viewport: PropTypes.oneOf(['desktop', 'tablet', 'mobile']),

  /**
   * @ignore
   * If provided a new Checkbox element will render
   */
  Checkbox: PropTypes.func,

  /**
   * @ignore
   * Padding bottom of the last element of a CheckBoxGroup
   */
  lastChildPadding: PropTypes.string,

  /**
   * This callback is fired when a value of a checkbox within the group has changed.
   */
  onChange: PropTypes.func,

  /**
   * Allows a unique ID to be passed to the component.
   */
  id: PropTypes.string
};
var defaultProps = {
  childWidth: '100%',
  Checkbox: DefaultCheckbox,
  lastChildPadding: '6X',
  rowQuantity: {
    mobile: 1,
    tablet: 2,
    desktop: 3
  },
  viewport: 'desktop',
  onChange: undefined
};
var CheckboxGroupWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "CheckboxGroupWrapper",
  componentId: "sc-1dtujjq-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  flex-wrap: wrap;\n"])));

var CheckboxGroup = /*#__PURE__*/function (_Component) {
  _inherits(CheckboxGroup, _Component);

  var _super = _createSuper(CheckboxGroup);

  function CheckboxGroup(props) {
    var _this;

    _classCallCheck(this, CheckboxGroup);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "id", cuid());

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function () {
      _this.state.id && _this.state.keyboardSelected && document.getElementById(_this.state.id).focus(); //refocus element
    });

    _defineProperty(_assertThisInitialized(_this), "_onChange", function (e, obj) {
      var selected = obj.selected,
          index = obj.index;
      var newData = _this.state.data;
      newData[index].selected = selected;

      _this.setState({
        data: newData,
        id: e.target.id
      }); //track id due to loss of focus on state change


      _this.props.onChange && _this.props.onChange(e, newData);
    });

    _defineProperty(_assertThisInitialized(_this), "_keySelected", function (value) {
      if (value !== _this.state.keyboardSelected) {
        _this.setState({
          keyboardSelected: value
        });
      }
    });

    _this.state = {
      data: props.data,
      keySelected: false
    };
    return _this;
  }

  _createClass(CheckboxGroup, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          data = _this$props.data,
          childWidth = _this$props.childWidth,
          viewport = _this$props.viewport,
          onChange = _this$props.onChange,
          Checkbox = _this$props.Checkbox,
          lastChildPadding = _this$props.lastChildPadding,
          className = _this$props.className,
          id = _this$props.id;
      return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(CheckboxGroupWrapper, {
        viewport: viewport,
        id: id,
        className: className
      }, data.map(function (child, index) {
        var inputId = child.inputId;
        var btnWidth = childWidth ? childWidth : child.width || '100%';
        return /*#__PURE__*/React.createElement(CheckboxGroupItem, _extends({
          keyboardSelected: _this2._keySelected,
          inputId: inputId ? inputId : _this2.id + index,
          Checkbox: Checkbox,
          lastChildPadding: lastChildPadding,
          width: btnWidth,
          key: index,
          onChange: _this2._onChange,
          index: index,
          selected: _this2.state.data[index].selected ? _this2.state.data[index].selected : false
        }, child));
      })));
    }
  }]);

  return CheckboxGroup;
}(Component);

CheckboxGroup.propTypes = propTypes;
CheckboxGroup.defaultProps = defaultProps;
export default withVDSManager(CheckboxGroup);